function checkDoorStatus(boxNumber, successCallback, errorCallback, notifyCallback) {
    var url = process.env.VUE_APP_API_SERVER + '/box/' + boxNumber + "/inspect"
    var accessToken = localStorage.getItem('accessToken')

    fetch(url, {
        method: "GET",
        headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Token': accessToken
        })
    }).then(res => {
        if (!res.ok) { throw res }
        return res.json()
    }).catch(error => {
        notifyCallback(error)
    }).then(response => {
        if (response.Status == 0) {
            if (response.Resp == "device offline") {
                notifyCallback("设备离线")
            } else {
                var resp = JSON.parse(response.Resp)

                if (resp.length == 0) {
                    successCallback(boxNumber)
                } else {
                    var respErrors = []

                    for (var i = 0; i < resp.length; i++) {
                        respErrors = respErrors.concat(resp[i].errors)
                    }
                    errorCallback(JSON.stringify(respErrors))
                }
            }
        } else if (response.Status == 2) {
            notifyCallback("主控和货柜已经绑定")
        } else if (response.Status == 3) {
            notifyCallback("服务器内部错误")
        }
    })
}

export {
    checkDoorStatus
}
